import React from 'react';
import rightArrowIcon from '../../assets/images/righArrowIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { WidgetElement } from '../../types/WidgetElement';
import {
    setWidgetModalOpen,
    setWidgetModalUrl,
} from '../../features/widgetModal/WidgetModalOpenSlice';
interface WidgetChapterItemProps {
    item: WidgetElement;
}

const WidgetItem: React.FC<WidgetChapterItemProps> = ({ item }) => {
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(setWidgetModalOpen(true));
        dispatch(setWidgetModalUrl(item.href));
    };
    return (
        <div className="chapter-item px-6 py-3 hover:bg-[#F7F9FD]">
            <button
                data-testid="widget-chapter-item-button"
                onClick={handleClick}
                className="w-full h-12 bg-transparent rounded text-black flex flex-row justify-between text-md items-center"
            >
                <div className="flex flex-row items-center">
                    <span className={` text-lg `}>{item.title}</span>
                </div>
                <div className="flex flex-row items-center">
                    <span className="text-[#666666] w-1 text-left">
                        {/* {chapter.page - offset} */}
                    </span>
                    <span className="pl-20 pr-4">
                        <img src={rightArrowIcon} alt="right arrow icon" />
                    </span>
                </div>
            </button>
        </div>
    );
};

export default WidgetItem;
